<template>
    <div class="icon-input">
        <img :src="icon" alt="icon" class="input-icon" />
        <input
            type="text"
            v-model="validation[identifier].$model"
            :placeholder="placeholder"
            :class="
                validation[identifier].$dirty && validation[identifier].$invalid
                    ? `${identifier}-icon-input-field error-input`
                    : `${identifier}-icon-input-field`
            "
        />
        <span
            v-if="errorMsg && validation[identifier].$dirty && validation[identifier].$invalid"
            class="error-msg"
        >
            {{ errorMsg }}
        </span>
    </div>
</template>
<script>
    export default {
        name: 'IconInput',
        props: {
            identifier: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false,
                default: '/images/icons/instagram-grey.svg'
            },
            validation: {
                type: Object,
                required: true
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            errorMsg: {
                type: String,
                required: false,
                default: ''
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .icon-input {
        width: 100%;
        position: relative;

        .input-icon {
            position: absolute;
            left: 12px;
            top: 10px;
            width: 20px;
            height: 20px;
            object-fit: cover;
        }

        .error-input {
            border-color: #ed3c0d;
            margin-bottom: 10px;
        }

        input {
            width: 100%;
            height: 40px;
            padding: 10px 12px;
            padding-left: 40px;
            border-radius: 8px;
            border: 1px solid #8b8b8b;
            background: inherit;
            overflow: hidden;
            color: #dedede;
            text-overflow: ellipsis;
            @include base-font-16;
            line-height: 125%;
        }
        input::placeholder {
            overflow: hidden;
            color: #646464;
            text-overflow: ellipsis;
            @include base-font-16;
            line-height: 125%;
        }
        .error-msg {
            position: absolute;
            bottom: 0;
            left: 0;
            color: #ed3c0d;
            font-family: Instrument Sans;
            font-size: 8px;
            font-style: normal;
            font-weight: 600;
            line-height: 130%;
            letter-spacing: 0.14px;
            text-wrap: nowrap;
        }
    }
</style>
